import "./time-slip-view.css";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import axios from "axios";
import msiLogo from "./assets/Micro Strategies Logo 2025_RBG_Primary Horizontal_White_1200 px.png";
import dragInsightsLogo from "./assets/drag-insights-logos-lights-white.png";
import { useNavigate } from "react-router-dom";
import { FaPrint, FaExchangeAlt, FaShareAlt, FaEye } from "react-icons/fa";
import { toPng } from "html-to-image";
import {
  API_LATEST_RECORD_URL,
  API_LATEST_RACE_KEY_URL,
  API_TRACK_STATUS_URL,
  API_CSRF_URL,
} from "./utils/apiUrlList";
import { API_TIME_SLIP_URL } from "./utils/apiUrlList";
import {
  TRACK_LIST_API,
  API_NAVIGATE_RACE_URL,
  getSearchApiUrl,
  LATEST_TRACK_API,
} from "./utils/apiUrlList";
import {
  API_DELTA_VALUE_URL,
  API_KEY_FETCH_RACE_DATA,
  API_WATCHLIST_URL,
} from "./utils/apiUrlList";
import { TRACK_EVENT_SELECTION_KEY } from "./TrackEventSelector";
import { useTour } from "./hooks/useTour";
import { isSlipReady } from "./utils/slipReadiness";
import { useAuth } from "./AuthProvider";
import {api} from "./utils/apiClientWithCsrf"
// import { getClassIndex, getOverUnder } from "./utils/raceIndex";

import { useDomainConfig } from "./utils/trackListFilter";

import { useDeviceOS } from "./hooks/useDeviceOS";
import { useInstallPrompt } from "./hooks/useInstallPrompt";
import InstallPromptBanner from "./components/InstallPromptBanner";

const TIMESLIP_TOUR_STEPS = () => [
  {
    element: '#tour-slip-nav',
    popover: {
      title: 'Navigate Runs',
      description: 'Tap the arrows or swipe left/right to move between runs.',
    },
  },
  {
    element: '#tour-slip-drivers',
    popover: {
      title: 'Driver & Car Info',
      description: 'Tap a driver name, car number, or class to search all their runs. The ⇄ icon compares this run to their previous one.',
    },
  },
  {
    element: '#tour-slip-times',
    popover: {
      title: 'Timing Data',
      description: 'Full breakdown: reaction time, 60-foot, 1/8 mile, 1000-foot, and 1/4 mile ET and MPH.',
    },
  },
];

const TimeSlipView = () => {
  const { user } = useAuth();
  const { showAndroidPrompt, showIOSGuide, handleInstallClick, handleDismiss, isAndroid, isIOS } = useInstallPrompt();

  const [timeSlipResults, setTimeSlipResults] = useState([]);
  const [mov, setMov] = useState("");
  const [eventName, setEventName] = useState(
    (() => {
      try {
        const r = localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
        return r ? JSON.parse(r).eventName || "" : "";
      } catch {
        return "";
      }
    })(),
  );
  const [category, setCategory] = useState("");
  const [round, setRound] = useState("");
  const [loading, setLoading] = useState(true);
  const [sharing, setSharing] = useState(false);

  // Capture target for the Share button (the on-screen slip content).
  const slipRef = useRef(null);

  const { startIfNew } = useTour('timeslip', TIMESLIP_TOUR_STEPS);

  useEffect(() => {
    if (!loading && timeSlipResults && timeSlipResults.length > 0) {
      startIfNew();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

 
  const [showModal, setShowModal] = useState(false);

  const [carNumberWishlistLeft, setCarNumberWishlistLeft] = useState(false);
  const [carNumberWishlistIdLeft, setCarNumberWishlistIdLeft] = useState(0);
  const [carNumberWishlistRight, setCarNumberWishlistRight] = useState(false);
  const [carNumberWishlistIdRight, setCarNumberWishlistIdRight] = useState(0);

  const [driverNameWishlistLeft, setDriverNameWishlistLeft] = useState(false);
  const [driverNameWishlistIdLeft, setDriverNameWishlistIdLeft] = useState(0);
  const [driverNameWishlistRight, setDriverNameWishlistRight] = useState(false);
  const [driverNameWishlistIdRight, setDriverNameWishlistIdRight] = useState(0);

  const userId = user?.id ?? null;


    const domainConfig = useDomainConfig();

    useEffect(() => {
  if (!domainConfig) return;  // Wait for domain to load

  const savedSelection = localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
  if (!savedSelection) return;

  const { trackName } = JSON.parse(savedSelection);

  if (domainConfig !== "all tracks" && trackName !== domainConfig) {
    alert("Access to this race is restricted.");
    navigate("/editTrackEvent");
  }
}, [domainConfig]);

// Clear install prompt dismissal on every page load (for testing)
useEffect(() => {
  localStorage.removeItem('installPromptDismissed');
}, []);

 



//      const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   withCredentials: true,          // send the session + XSRF cookies
//   // xsrfCookieName: "XSRF-TOKEN",   // cookie Spring sets
//   // xsrfHeaderName: "X-XSRF-TOKEN", // header Spring expects
// });
//      function getCookie(name) {
//   return document.cookie.split("; ").find(r => r.startsWith(name + "="))?.split("=")[1];
// }
// api.interceptors.request.use(config => {
//   const token = getCookie("XSRF-TOKEN");
//   if (token) config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token);
//   return config;
// });



const handleCarNumberWishlist = async (key, index) => {
  const isLeft = index === 0;
  const isWishlisted = isLeft ? carNumberWishlistLeft : carNumberWishlistRight;
  const wishlistId = isLeft ? carNumberWishlistIdLeft : carNumberWishlistIdRight;
  const setWishlist = isLeft ? setCarNumberWishlistLeft : setCarNumberWishlistRight;
  const setWishlistId = isLeft ? setCarNumberWishlistIdLeft : setCarNumberWishlistIdRight;

  if (!isWishlisted) {
    console.log(key);
    const requestData = { name: key, type: "CAR_NO", userId: userId };
    const res = await api.post(API_WATCHLIST_URL, requestData);
    setWishlist(true);
    setWishlistId(res.data.id);
  } else {
    await api.delete(`${API_WATCHLIST_URL}/${wishlistId}`);
    setWishlist(false);
  }
};

  // const handleCarNumberWishlist = async (key) => {
  //    const csrfToken = document.cookie
  // .split('; ')
  // .find(row => row.startsWith('XSRF-TOKEN='))
  // ?.split('=')[1];

  //   if(carNumberWishlist != true){

  //   const requestData = {
  //     name: key,
  //     type: "CAR_NO",
  //   }
  //   const response = await axios.post(API_WATCHLIST_URL, requestData, {
  //   headers: {
  //       'Content-Type': 'application/json',
  //       'X-XSRF-TOKEN': csrfToken
  //     },
  //     withCredentials: true
  //   });
  //   setCarNumberWishlist(true);
  //   setCarNumberWishlistId(response.data.id)
  // }
  //   const response = await axios.delete(`${API_WATCHLIST_URL}/${carNumberWishlistId}`, {
  //   headers: {
  //       'Content-Type': 'application/json',
  //       'X-XSRF-TOKEN': csrfToken
  //     },
  //     withCredentials: true
  //   });
  //   setCarNumberWishlist(false)
  // };
//   async function initCsrf() {
//   const { data } = await api.get(API_CSRF_URL);
//   api.defaults.headers.common[data.headerName] = data.token; // X-XSRF-TOKEN
// }

  const handleDriverNameWishlist = async (key, index) => {
    const isLeft = index === 0;
    const isWishlisted = isLeft ? driverNameWishlistLeft : driverNameWishlistRight;
    const wishlistId = isLeft ? driverNameWishlistIdLeft : driverNameWishlistIdRight;
    const setWishlist = isLeft ? setDriverNameWishlistLeft : setDriverNameWishlistRight;
    const setWishlistId = isLeft ? setDriverNameWishlistIdLeft : setDriverNameWishlistIdRight;

    if (!isWishlisted) {
      const requestData = { name: key, type: "DRIVER" , userId: userId };
      try {
        const response = await api.post(API_WATCHLIST_URL, requestData);
        setWishlist(true);
        setWishlistId(response.data.id);
      } catch (e) {
        console.log("There is an issue while adding driver name to the wishlist");
      }
    } else {
      try {
        await api.delete(`${API_WATCHLIST_URL}/${wishlistId}`);
        setWishlist(false);
      } catch (e) {
        console.log("There is an issue while removing driver name from the wishlist");
      }
    }
  };

  const [selectedDriver, setSelectedDriver] = useState(null);

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(eventName);

  const [mov_inches, setMov_inches] = useState("");

  const [raceUniqueId, setRaceUniqueId] = useState("");

  const [handleFirstData, setHandleFirstData] = useState(false);
  const [handleChangeIncreRaceIdData, setHandleChangeIncreRaceIdData] =
    useState(false);
  const [handleChangeDirection, setHandleChangeDirection] = useState(false);
  const isFirstRender = useRef(true);

  const latestRaceKeyIdRef = useRef(0);

  const location = useLocation();

  const race_Key_id = location.state?.raceKeyid;

  // Search-result swipe list. Stateful so we can append more entries when
  // the user swipes past the last item (mirrors SearchView's infinite scroll).
  const [increRaceIdList, setIncreRaceIdList] = useState(() => [
    ...new Set(location.state?.increRaceIdList || []),
  ]);

  // Search context for fetching additional pages (only set when arriving from
  // SearchView with listFlag === 1).
  const searchContextRef = useRef(location.state?.searchContext || null);
  const [hasMoreSearch, setHasMoreSearch] = useState(true);
  const loadingMoreSearchRef = useRef(false);

  const [trackList, setTrackList] = useState([]);

  const trackOptions = [...new Set(trackList.map((item) => item.trackName))];

  const [eventId, setEventId] = useState(
    (() => {
      try {
        const r = localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
        return r ? JSON.parse(r).eventId || "" : "";
      } catch {
        return "";
      }
    })(),
  );
  const eventIdRef = useRef(
    (() => {
      try {
        const r = localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
        return r ? JSON.parse(r).eventId || "" : "";
      } catch {
        return "";
      }
    })(),
  );

  const [mainScreenFlag, setMainScreenFlagValue] = useState(false);

  const [racekeyId, setRaceKeyId] = useState(race_Key_id);
  const raceKeyIdRef = useRef(racekeyId);

  const [directionFlag, setDirectionFlag] = useState("");

  // Read persisted track/event selection from localStorage
  const _savedSelection = (() => {
    try {
      const raw = localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();

  const [selectedValue, setSelectedValue] = useState(
    _savedSelection?.trackName || "",
  );
  const [selectedEventValue, setSelectedEventValue] = useState(
    _savedSelection?.eventId || "",
  );

  const [trackName, setTrackName] = useState(_savedSelection?.trackName || "-");

  const eventOptions = trackList
    .filter((item) => item.trackName === selectedValue)
    .map((item) => ({ eventName: item.eventName, eventId: item.eventId }));

  const [lastDataCheckFlag, setLastDataCheckFlag] = useState(false);

  // Bumped on a timer so the readiness gate re-evaluates as the age-based
  // threshold elapses, even when no new data has arrived.
  const [, setReadinessTick] = useState(0);

  const navigate = useNavigate();

  let listFlag = location.state?.listFlag;
  if (listFlag === undefined || listFlag === null) {
    listFlag = 0;
  }

  const getTrackList = async () => {
    try {
      const response = await api.get(TRACK_LIST_API, {
        withCredentials: true,
      });

      const data = response.data;
      setTrackList(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSearch = () => {
    // Persist the new selection to localStorage so it survives browser close/reopen
    // and carries over to the search page
    const newSelection = {
      trackName: selectedValue,
      eventId: selectedEventValue,
      eventName: eventName,
    };
    localStorage.setItem(
      TRACK_EVENT_SELECTION_KEY,
      JSON.stringify(newSelection),
    );
    eventIdRef.current = selectedEventValue;
    setMainScreenFlagValue((prev) => !prev);
    setModalOpen(false);
  };

  // const handleChange = (event) => {
  //   setSelectedValue(event.target.value);
  //   setSelectedEventValue("");
  //   setEventId("");
  //   setEventName("");
  //   setTrackName(event.target.value);
  // };

  // const openModal = async () => {
  //   setModalOpen(true);
  //   await getTrackList();
  // };

  // const handleEventNameChange = (event) => {
  //   const selectedEventId = event.target.value;

  //   setSelectedEventValue(selectedEventId);
  //   setEventId(selectedEventId);

  //   const selectedEventObj = eventOptions.find(
  //     (e) => e.eventId === selectedEventId,
  //   );

  //   if (selectedEventObj) {
  //     setEventName(selectedEventObj.eventName);
  //   }
  // };

  const goAutoSearch = (field, value) => {
    if (!value || value === "NA") return;
    navigate("/searchView", {
      state: { autoSearch: { field, value: String(value) } },
    });
  };

  const handleLatestData = () => {
    // Reset the race-key pointer so the next fetch returns the latest race
    // for the currently-selected event. Keep eventId / eventIdRef intact so
    // the API call stays scoped to that event.
    setRaceKeyId(0);
    raceKeyIdRef.current = 0;
    setHandleFirstData((p) => !p);
  };

  // Fetch the next page of search results when the user swipes past the
  // last entry of the in-memory list. Returns the new raceKeys (possibly
  // empty when there are no more pages).
  const loadMoreSearchResults = async () => {
    if (loadingMoreSearchRef.current) return [];
    const ctx = searchContextRef.current;
    if (!ctx || !ctx.payload) return [];
    if (!hasMoreSearch) return [];

    loadingMoreSearchRef.current = true;
    const nextPage = (ctx.searchPage || 0) + 1;

    try {
      const response = await api.post(
        getSearchApiUrl(nextPage),
        ctx.payload,
        {
          withCredentials: true,
        },
      );
      const data = response.data || [];

      if (data.length === 0) {
        setHasMoreSearch(false);
        return [];
      }

      const newRaceKeys = data.map((event) => event.raceKey);

      // Append to the in-memory list driving the swipe navigation.
      setIncreRaceIdList((prev) => {
        const merged = [...prev];
        for (const k of newRaceKeys) if (!merged.includes(k)) merged.push(k);
        return merged;
      });

      // Mirror SearchView's row shape so the result cards line up on return.
      const newResults = data.map((event) => ({
        carNumber: event.carNo,
        carClass: event.carClass,
        driver: event.driver,
        date: event.dateTimeStamp,
        round: event.round,
        win: event.win || "",
        race_day_race_id: event.raceDayRaceId,
        dateOnly: event.dateTimeStamp,
        raceKey: event.raceKey,
        raceUniqueId: event.raceUniqueId,
        dial_in:
          typeof event.dialIn === "number"
            ? event.dialIn.toFixed(3)
            : event.dialIn || "NA",
        rt:
          typeof event.rt === "number" ? event.rt.toFixed(3) : event.rt || "NA",
        ft60:
          typeof event.ft60 === "number"
            ? event.ft60.toFixed(3)
            : event.ft60 || "NA",
        ft330:
          typeof event.ft330 === "number"
            ? event.ft330.toFixed(3)
            : event.ft330 || "NA",
        ft8:
          typeof event.ft8 === "number"
            ? event.ft8.toFixed(3)
            : event.ft8 || "NA",
        ft8mph:
          typeof event.ft8mph === "number"
            ? event.ft8mph.toFixed(3)
            : event.ft8mph || "NA",
        ft1000:
          typeof event.ft1000 === "number"
            ? event.ft1000.toFixed(3)
            : event.ft1000 || "NA",
        ft4:
          typeof event.ft4 === "number"
            ? event.ft4.toFixed(3)
            : event.ft4 || "NA",
        ft4mph:
          typeof event.ft4mph === "number"
            ? event.ft4mph.toFixed(3)
            : event.ft4mph || "NA",
        opponentDriverName: event.opponentDriver
          ? event.opponentDriver.driver
          : "NA",
        opponentDriverCarNo: event.opponentDriver
          ? event.opponentDriver.carNo
          : "NA",
      }));

      // Keep SearchView's persisted state in sync so a return visit sees the
      // merged result cards and resumes paging from the right page.
      try {
        const savedResults = localStorage.getItem("searchResults");
        const prevResults = savedResults ? JSON.parse(savedResults) : [];
        localStorage.setItem(
          "searchResults",
          JSON.stringify([...prevResults, ...newResults]),
        );

        const savedKeys = localStorage.getItem("increRaceIdList");
        const prevKeys = savedKeys ? JSON.parse(savedKeys) : [];
        const mergedKeys = [...prevKeys];
        for (const k of newRaceKeys)
          if (!mergedKeys.includes(k)) mergedKeys.push(k);
        localStorage.setItem("increRaceIdList", JSON.stringify(mergedKeys));

        localStorage.setItem("searchPage", JSON.stringify(nextPage));
      } catch (err) {
        console.error("Failed to update search caches after load-more:", err);
      }

      // Advance our local search context so the next call asks for the page
      // after this one.
      searchContextRef.current = { ...ctx, searchPage: nextPage };

      return newRaceKeys;
    } catch (err) {
      console.error("Load more search results failed:", err);
      return [];
    } finally {
      loadingMoreSearchRef.current = false;
    }
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleBackToMainScreen = () => {
    setMainScreenFlagValue(true);
  };

  const handleSwipeLeft = async () => {
    setShowModal(false);
    if (listFlag === 0) {
      setDirectionFlag("next");
      setHandleChangeDirection((p) => !p);
    } else if (listFlag === 1) {
      if (increRaceIdList && increRaceIdList.length > 0) {
        const currentIndex = increRaceIdList.indexOf(racekeyId);
        if (currentIndex > 0) {
          const newRaceKeyId = increRaceIdList[currentIndex - 1];
          setRaceKeyId(newRaceKeyId);
          raceKeyIdRef.current = newRaceKeyId;
          await fetchDataFromTimeSlipApi();
        } else {
          alert("Start of the list reached");
        }
      }
    }
  };

  const handleSwipeRight = async () => {
    setShowModal(false);
    if (listFlag === 0) {
      if (racekeyId === 0 && raceKeyIdRef.current === 0) {
        setLastDataCheckFlag(true);
      }
      setDirectionFlag("previous");
      setHandleChangeDirection((p) => !p);
    } else if (listFlag === 1) {
      if (increRaceIdList && increRaceIdList.length > 0) {
        const currentIndex = increRaceIdList.indexOf(racekeyId);
        if (currentIndex >= 0 && currentIndex < increRaceIdList.length - 1) {
          const newRaceKeyId = increRaceIdList[currentIndex + 1];
          setRaceKeyId(newRaceKeyId);
          raceKeyIdRef.current = newRaceKeyId;
          await fetchDataFromTimeSlipApi();
        } else if (searchContextRef.current && hasMoreSearch) {
          if (loadingMoreSearchRef.current) {
            return; // a load is already in flight; ignore this swipe
          }
          const fetched = await loadMoreSearchResults();
          if (fetched.length > 0) {
            const newRaceKeyId = fetched[0];
            setRaceKeyId(newRaceKeyId);
            raceKeyIdRef.current = newRaceKeyId;
            await fetchDataFromTimeSlipApi();
          } else {
            alert("End of the list reached");
          }
        } else {
          alert("End of the list reached");
        }
      }
    }
  };

  const handleLeftArrowClick = async () => {
    setShowModal(false);
    if (listFlag === 0) {
      if (racekeyId === 0 && raceKeyIdRef.current === 0) {
        setLastDataCheckFlag(true);
      }
      setDirectionFlag("previous");
      setHandleChangeDirection((p) => !p);
    } else if (listFlag === 1) {
      if (increRaceIdList && increRaceIdList.length > 0) {
        const currentIndex = increRaceIdList.indexOf(racekeyId);
        if (currentIndex >= 0 && currentIndex < increRaceIdList.length - 1) {
          const newRaceKeyId = increRaceIdList[currentIndex + 1];
          setRaceKeyId(newRaceKeyId);
          raceKeyIdRef.current = newRaceKeyId;
          await fetchDataFromTimeSlipApi();
        } else if (searchContextRef.current && hasMoreSearch) {
          if (loadingMoreSearchRef.current) {
            return; // a load is already in flight; ignore this click
          }
          const fetched = await loadMoreSearchResults();
          if (fetched.length > 0) {
            const newRaceKeyId = fetched[0];
            setRaceKeyId(newRaceKeyId);
            raceKeyIdRef.current = newRaceKeyId;
            await fetchDataFromTimeSlipApi();
          } else {
            alert("End of the list reached");
          }
        } else {
          alert("End of the list reached");
        }
      }
    }
  };

  const handleRightArrowClick = async () => {
    setShowModal(false);
    if (listFlag === 0) {
      setDirectionFlag("next");
      setHandleChangeDirection((p) => !p);
    } else if (listFlag === 1) {
      if (increRaceIdList && increRaceIdList.length > 0) {
        const currentIndex = increRaceIdList.indexOf(racekeyId);
        if (currentIndex > 0) {
          const newRaceKeyId = increRaceIdList[currentIndex - 1];
          setRaceKeyId(newRaceKeyId);
          raceKeyIdRef.current = newRaceKeyId;
          await fetchDataFromTimeSlipApi();
        } else {
          alert("Start of the list reached");
        }
      }
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleSwipeLeft,
    onSwipedRight: handleSwipeRight,
    preventDefaultTouchmoveEvent: true,
  });

  const handlePrint = () => {
    try {
      window?.print?.();
    } catch (e) {
      console.error("Print failed", e);
    }
  };

  // Interactive controls we don't want baked into the shared image.
  const SHARE_EXCLUDE = [
    "arrow-button",
    "event-header-print",
    "share-button",
    "driver-details-btn",
  ];
  const shareCaptureFilter = (node) => {
    if (node?.classList) {
      for (const c of SHARE_EXCLUDE) {
        if (node.classList.contains(c)) return false;
      }
    }
    return true;
  };

  const hasVal = (v) => v && v !== "NA" && v !== "-";

  // Concise summary that rides along with the image (and works on its own in
  // text-only contexts / desktop clipboard fallback).
  const buildShareText = () => {
    const racers = timeSlipResults.filter((r) => hasVal(r.driver));
    if (racers.length === 0) return "";

    // A zero value counts as empty (1/4 ET comes back as 0.000 on 1/8 races).
    const hasNum = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) && n !== 0;
    };

    const lines = [];

    // Header — each on its own line for narrow message bubbles.
    lines.push("raceresults.1320cc.com");
    if (hasVal(trackName)) lines.push(trackName);
    if (hasVal(formattedDate)) lines.push(formattedDate);
    if (hasVal(formattedTime)) lines.push(formattedTime);
    if (hasVal(category)) lines.push(category);
    if (hasVal(round)) lines.push(round);

    // Per racer (lane order): name, dial-in, final ET — stacked. Timing fields
    // are withheld until the run is finished (matches the on-screen gate).
    racers.forEach((r) => {
      const win = r.win === "WIN" ? " (W)" : "";
      lines.push("");
      lines.push(`${r.driver}${win}`);
      if (!slipReady) return;
      if (hasVal(r.dial_in)) lines.push(`Dial ${r.dial_in}`);
      const finalEt = hasNum(r.ft4) ? r.ft4 : hasNum(r.ft8) ? r.ft8 : null;
      if (finalEt) lines.push(`ET ${finalEt}`);
    });

    if (!slipReady) {
      lines.push("");
      lines.push("Run in progress — results pending");
    }

    return lines.join("\n");
  };

  const buildShareFileName = () => {
    const names = timeSlipResults
      .filter((r) => hasVal(r.driver))
      .map((r) => r.driver.trim().replace(/[^\w-]+/g, "_"))
      .join("_vs_");
    const base = names || "timeslip";
    const date = hasVal(formattedDate)
      ? formattedDate.replace(/\//g, "-")
      : "";
    return `${base}${date ? `-${date}` : ""}.png`;
  };

  const handleShare = async () => {
    const node = slipRef.current;
    if (!node || sharing) return;
    setSharing(true);
    // Add breathing room so the track-name line isn't clipped at the top edge.
    node.classList.add("sharing-capture");
    try {
      const dataUrl = await toPng(node, {
        pixelRatio: 2,
        backgroundColor: "#470271",
        cacheBust: true,
        filter: shareCaptureFilter,
      });
      const blob = await (await fetch(dataUrl)).blob();
      const fileName = buildShareFileName();
      const file = new File([blob], fileName, { type: "image/png" });
      const text = buildShareText();
      const title = "Race Results";

      // Mobile: native share sheet with image + caption.
      if (
        typeof navigator !== "undefined" &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        try {
          await navigator.share({ files: [file], title, text });
        } catch (err) {
          if (err && err.name === "AbortError") return; // user dismissed
          throw err;
        }
        return;
      }

      // Fallback (most desktops): download the PNG + copy the text summary.
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      try {
        await navigator?.clipboard?.writeText?.(text);
      } catch {
        /* clipboard is best-effort */
      }
    } catch (e) {
      console.error("Share failed", e);
      alert("Sorry, sharing the time slip failed. Please try again.");
    } finally {
      node.classList.remove("sharing-capture");
      setSharing(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);

    const trackStatusUrl = API_TRACK_STATUS_URL;
    try {
      const response = await api.get(`${trackStatusUrl}`, {
        params: { trackId: JSON.parse(localStorage.getItem("trackEventSelection")). trackId },
        withCredentials: true,
      });
      const data = response.data;
      if(data === "Inactive"){
        alert("The track associated with this run is currently inactive")
        localStorage.removeItem(TRACK_EVENT_SELECTION_KEY);
        navigate("/editTrackEvent");
      }
    } catch (error) {
      console.error("Error fetching track status:", error);
    }



    try{
    if(localStorage.getItem("allowEditSelection") === "true"){
         const response = await api.get(LATEST_TRACK_API, { 
          params: { trackId: JSON.parse(localStorage.getItem("trackEventSelection")).trackId },
          withCredentials: true });

          const data = response.data;
              const trackNameLocalStorageValue = JSON.parse(localStorage.getItem("trackEventSelection")).trackName;
            localStorage.setItem(TRACK_EVENT_SELECTION_KEY, JSON.stringify({
              trackName: trackNameLocalStorageValue,
              eventId: data.eventId,
              eventName: data.eventName,
              trackId: data.trackId,
              startDate: data.startDate,
              endDate: data.endDate,
            }));
            eventIdRef.current = data.eventId;
            setEventId(data.eventId);
            window.dispatchEvent(new CustomEvent("track-changed"));
    }
  }
    catch (error) {
      console.error("Error fetching latest event by track ID:", error);
    }

    if (raceKeyIdRef.current) {
      await fetchDataFromTimeSlipApi();
      return;
    }

    const requestData = {
      eventId: eventIdRef.current,
    };

    listFlag = 0;

    const apiUrl = API_LATEST_RACE_KEY_URL;

    try {
      const response = await api.get(`${apiUrl}`, {
        params: {
          eventId: eventIdRef.current,
        },
        withCredentials: true,
      });
      const data = response.data;

      const timeSlipResults = data.map((event) => ({
        race_lane_result_id: event.raceLaneResultId || "NA",
        race_day_race_id: event.raceDayRaceId || "NA",
        car_no: event.carNo || "NA",
        driver: event.driver || "NA",
        car_class: event.carClass || "NA",
        rt:
          typeof event.rt === "number" ? event.rt.toFixed(3) : event.rt || "NA",
        rt_str: event.rtStr || "NA",
        ft60:
          typeof event.ft60 === "number"
            ? event.ft60.toFixed(3)
            : event.ft60 || "NA",
        ft330:
          typeof event.ft330 === "number"
            ? event.ft330.toFixed(3)
            : event.ft330 || "NA",
        win: event.win || "NA",
        dial_in:
          typeof event.dialIn === "number"
            ? event.dialIn.toFixed(3)
            : event.dialIn || "NA",
        mov: event.mov || "NA",
        lane: event.lane || "NA",
        // ft8str: event.ft8str || "NA",
        ft8:
          typeof event.ft8 === "number"
            ? event.ft8.toFixed(3)
            : event.ft8 || "NA",
        ft8mph:
          typeof event.ft8mph === "number"
            ? event.ft8mph.toFixed(3)
            : event.ft8mph || "NA",
        ft1000:
          typeof event.ft1000 === "number"
            ? event.ft1000.toFixed(3)
            : event.ft1000 || "NA",
        ft4:
          typeof event.ft4 === "number"
            ? event.ft4.toFixed(3)
            : event.ft4 || "NA",
        ft4mph: event.ft4mph || "NA",
        race_date: event.raceDate || "NA",
        eventName: event.eventName || "NA",
        trackName: event.trackName || "NA",
        category: event.category || "NA",
        round: event.round || "NA",
        raceUniqueId: event.raceUniqueId || "NA",
        first:
          typeof event.first === "number"
            ? event.first.toFixed(3)
            : event.first || "NA",
        movInches: event.movInches || "NA",
        eventId: event.eventId || "NA",
        raceKey: event.raceKey || "NA",
        indexUsed: event.indexUsed || "NA",
        overUnderQuarterMile: event.overUnderQuarterMile || "NA",
        overUnderEighthMile: event.overUnderEighthMile || "NA",
        overUnder: event.overUnder || "NA",
        driverWatched: event.driverWatched || false,
        carNoWatched: event.carNoWatched || false,
      }));

      setTimeSlipResults(timeSlipResults);
      setCarNumberWishlistLeft(!!timeSlipResults[0]?.carNoWatched);
      setCarNumberWishlistRight(!!timeSlipResults[1]?.carNoWatched);
      setDriverNameWishlistLeft(!!timeSlipResults[0]?.driverWatched);
      setDriverNameWishlistRight(!!timeSlipResults[1]?.driverWatched);

      if (timeSlipResults.length > 0) {
        const firstResult = timeSlipResults[0];
        setMov(firstResult.mov ? firstResult.mov : "NA");
        setEventName(firstResult.eventName ? firstResult.eventName : "NA");
        setTrackName(firstResult.trackName ? firstResult.trackName : "NA");
        setCategory(firstResult.category ? firstResult.category : "NA");
        setRound(firstResult.round ? firstResult.round : "NA");
        setRaceKeyId(firstResult.raceKey);
        raceKeyIdRef.current = firstResult.raceKey;
        latestRaceKeyIdRef.current = firstResult.raceKey;
        setRaceUniqueId(firstResult.raceUniqueId);
        setMov_inches(firstResult.movInches ? firstResult.movInches : "NA");
        setEventId(firstResult.eventId || "");
      }

      setLoading(false);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const fetchDataFromTimeSlipApi = async () => {
    setLoading(true);

    const requestData = {
      eventId: eventIdRef.current,
      raceKey: raceKeyIdRef.current,
    };

    listFlag = 0;

    const apiUrl = API_TIME_SLIP_URL;

    try {
      const response = await api.post(apiUrl, requestData, {
        withCredentials: true,
      });
      const data = response.data;

      const timeSlipResults = data.map((event) => ({
        race_lane_result_id: event.raceLaneResultId || "NA",
        race_day_race_id: event.raceDayRaceId || "NA",
        car_no: event.carNo || "NA",
        driver: event.driver || "NA",
        car_class: event.carClass || "NA",
        rt:
          typeof event.rt === "number" ? event.rt.toFixed(3) : event.rt || "NA",
        rt_str: event.rtStr || "NA",
        ft60:
          typeof event.ft60 === "number"
            ? event.ft60.toFixed(3)
            : event.ft60 || "NA",
        ft330:
          typeof event.ft330 === "number"
            ? event.ft330.toFixed(3)
            : event.ft330 || "NA",
        win: event.win || "NA",
        dial_in:
          typeof event.dialIn === "number"
            ? event.dialIn.toFixed(3)
            : event.dialIn || "NA",
        mov: event.mov || "NA",
        lane: event.lane || "NA",
        // ft8str: event.ft8str || "NA",
        ft8:
          typeof event.ft8 === "number"
            ? event.ft8.toFixed(3)
            : event.ft8 || "NA",
        ft8mph:
          typeof event.ft8mph === "number"
            ? event.ft8mph.toFixed(3)
            : event.ft8mph || "NA",
        ft1000:
          typeof event.ft1000 === "number"
            ? event.ft1000.toFixed(3)
            : event.ft1000 || "NA",
        ft4:
          typeof event.ft4 === "number"
            ? event.ft4.toFixed(3)
            : event.ft4 || "NA",
        ft4mph: event.ft4mph || "NA",
        race_date: event.raceDate || "NA",
        eventName: event.eventName || "NA",
        trackName: event.trackName || "NA",
        category: event.category || "NA",
        round: event.round || "NA",
        raceUniqueId: event.raceUniqueId || "NA",
        first:
          typeof event.first === "number"
            ? event.first.toFixed(3)
            : event.first || "NA",
        movInches: event.movInches || "NA",
        eventId: event.eventId || "NA",
        raceKey: event.raceKey || "NA",
        indexUsed: event.indexUsed || "NA",
        overUnderQuarterMile: event.overUnderQuarterMile || "NA",
        overUnderEighthMile: event.overUnderEighthMile || "NA",
        overUnder: event.overUnder || "NA",
        driverWatched: event.driverWatched || false,
        carNoWatched: event.carNoWatched || false,
      }));

      setTimeSlipResults(timeSlipResults);
      setCarNumberWishlistLeft(!!timeSlipResults[0]?.carNoWatched);
      setCarNumberWishlistRight(!!timeSlipResults[1]?.carNoWatched);
      setDriverNameWishlistLeft(!!timeSlipResults[0]?.driverWatched);
      setDriverNameWishlistRight(!!timeSlipResults[1]?.driverWatched);

      if (timeSlipResults.length > 0) {
        const firstResult = timeSlipResults[0];
        setMov(firstResult.mov ? firstResult.mov : "NA");
        setEventName(firstResult.eventName ? firstResult.eventName : "NA");
        setTrackName(firstResult.trackName ? firstResult.trackName : "NA");
        setCategory(firstResult.category ? firstResult.category : "NA");
        setRound(firstResult.round ? firstResult.round : "NA");
        setRaceKeyId(firstResult.raceKey);
        raceKeyIdRef.current = firstResult.raceKey;
        setRaceUniqueId(firstResult.raceUniqueId);
        setMov_inches(firstResult.movInches ? firstResult.movInches : "NA");
        setEventId(firstResult.eventId || "");
      }

      setLoading(false);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const fetchFreshData = async (raceKeyIdRefValue) => {
    if (latestRaceKeyIdRef.current === raceKeyIdRefValue) {
      try{
      if(localStorage.getItem("allowEditSelection") === "true"){
         const response = await api.get(LATEST_TRACK_API, { 
          params: { trackId: JSON.parse(localStorage.getItem("trackEventSelection")).trackId },
          withCredentials: true });

          const data = response.data;
              const trackNameLocalStorageValue = JSON.parse(localStorage.getItem("trackEventSelection")).trackName;
            localStorage.setItem(TRACK_EVENT_SELECTION_KEY, JSON.stringify({
              trackName: trackNameLocalStorageValue,
              eventId: data.eventId,
              eventName: data.eventName,
              trackId: data.trackId,
              startDate: data.startDate,
              endDate: data.endDate,
            }));
            eventIdRef.current = data.eventId;
            setEventId(data.eventId);
            window.dispatchEvent(new CustomEvent("track-changed"));
      
    }
  }
    catch (error) {
      console.error("Error fetching latest event by track ID:", error);
    }
    
      const latestRecordRaceKeyIdApiUrl = API_LATEST_RACE_KEY_URL;

      const latestRecordRaceKeyIdApiResponse = await api.get(
        latestRecordRaceKeyIdApiUrl,
        {
          params: {
            eventId: eventIdRef.current,
          },
          withCredentials: true,
        },
      );
      const latestRecordRaceKeyIdApiResponseData =
        latestRecordRaceKeyIdApiResponse.data;

      const latestRecordRaceKeyId =
        latestRecordRaceKeyIdApiResponseData[0].raceKey;

      if (
        latestRecordRaceKeyId !== latestRaceKeyIdRef.current ||
        latestRecordRaceKeyId === latestRaceKeyIdRef.current
      ) {
        // latestIncreIdRef.current =
        //   latestRecordRaceKeyIdApiResponseData.raceKey;
        latestRaceKeyIdRef.current = latestRecordRaceKeyId;
        raceKeyIdRef.current = latestRecordRaceKeyId;

        const requestData = {
          // increRaceId: latestRecordRaceKeyIdApiResponseData.raceKey,
          raceKey: latestRecordRaceKeyId,
          eventId: eventIdRef.current,
        };

        listFlag = 0;

        const apiUrl = API_TIME_SLIP_URL;

        try {
          const response = await api.post(apiUrl, requestData, {
            withCredentials: true,
          });

          const data = response.data;

          // ✅ HANDLE EMPTY / NO RESPONSE
          // if (!data || data.length === 0) {
          //   console.warn("No data received, rolling back increRaceId");
          //   console.log("Current increRaceId:", latestIncreIdRef.current);

          //   const newId = Math.max(0, raceKeyIdRefValue - 1);

          //   latestRaceKeyIdRef.current = newId;
          //   raceKeyIdRef.current = newId;

          //   console.log(
          //     "Rolled back increRaceId to:",
          //     latestRaceKeyIdRef.current,
          //   );

          //   return; //
          // }
          const timeSlipResults = data.map((event) => ({
            race_lane_result_id: event.raceLaneResultId || "NA",
            race_day_race_id: event.raceDayRaceId || "NA",
            car_no: event.carNo || "NA",
            driver: event.driver || "NA",
            car_class: event.carClass || "NA",
            rt:
              typeof event.rt === "number"
                ? event.rt.toFixed(3)
                : event.rt || "NA",
            rt_str: event.rtStr || "NA",
            ft60:
              typeof event.ft60 === "number"
                ? event.ft60.toFixed(3)
                : event.ft60 || "NA",
            ft330:
              typeof event.ft330 === "number"
                ? event.ft330.toFixed(3)
                : event.ft330 || "NA",
            win: event.win || "NA",
            dial_in:
              typeof event.dialIn === "number"
                ? event.dialIn.toFixed(3)
                : event.dialIn || "NA",
            mov: event.mov || "NA",
            lane: event.lane || "NA",
            ft8:
              typeof event.ft8 === "number"
                ? event.ft8.toFixed(3)
                : event.ft8 || "NA",
            ft8mph:
              typeof event.ft8mph === "number"
                ? event.ft8mph.toFixed(3)
                : event.ft8mph || "NA",
            ft1000:
              typeof event.ft1000 === "number"
                ? event.ft1000.toFixed(3)
                : event.ft1000 || "NA",
            ft4:
              typeof event.ft4 === "number"
                ? event.ft4.toFixed(3)
                : event.ft4 || "NA",
            ft4mph: event.ft4mph || "NA",
            race_date: event.raceDate || "NA",
            eventName: event.eventName || "NA",
            trackName: event.trackName || "NA",
            category: event.category || "NA",
            round: event.round || "NA",
            raceUniqueId: event.raceUniqueId || "NA",
            first:
              typeof event.first === "number"
                ? event.first.toFixed(3)
                : event.first || "NA",
            movInches: event.movInches || "NA",
            raceKey: event.raceKey || "NA",
            indexUsed: event.indexUsed || "NA",
            overUnderQuarterMile: event.overUnderQuarterMile || "NA",
            overUnderEighthMile: event.overUnderEighthMile || "NA",
            overUnder: event.overUnder || "NA",
            driverWatched: event.driverWatched || false,
            carNoWatched: event.carNoWatched || false,
          }));

          setTimeSlipResults(timeSlipResults);
          setCarNumberWishlistLeft(!!timeSlipResults[0]?.carNoWatched);
          setCarNumberWishlistRight(!!timeSlipResults[1]?.carNoWatched);
          setDriverNameWishlistLeft(!!timeSlipResults[0]?.driverWatched);
          setDriverNameWishlistRight(!!timeSlipResults[1]?.driverWatched);

          if (timeSlipResults.length > 0) {
            const firstResult = timeSlipResults[0];
            setMov(firstResult.mov ? firstResult.mov : "NA");
            setEventName(firstResult.eventName ? firstResult.eventName : "NA");
            setTrackName(firstResult.trackName ? firstResult.trackName : "NA");
            setCategory(firstResult.category ? firstResult.category : "NA");
            setRound(firstResult.round ? firstResult.round : "NA");
            setRaceKeyId(firstResult.raceKey);
            setRaceUniqueId(firstResult.raceUniqueId);
            setMov_inches(firstResult.movInches ? firstResult.movInches : "NA");
          }
          return data;
        } catch (error) {
          console.error("Error fetching data:", error);
          throw error;
        }
      }
    }
  };

  const fetchDataOnDirectionChange = async () => {
    if (directionFlag === "") {
      return;
    }
    setLoading(true);

    if (lastDataCheckFlag === true) {
      setLastDataCheckFlag(false);
      await fetchData();
      return;
    }

    const requestData = {
      eventId: eventIdRef.current,
      raceKey: raceKeyIdRef.current,
      direction: directionFlag,
    };

    listFlag = 0;

    const apiUrl = API_NAVIGATE_RACE_URL;

    try {
      const response = await api.post(apiUrl, requestData, {
        withCredentials: true,
      });
      const data = response.data;
      if (data.length === 0) {
        // No more data in this direction
        setLoading(false);

        if (directionFlag === "previous") {
          alert("Start of the list reached");
        } else {
          alert("End of the list reached");
        }

        return;
      }

      const timeSlipResults = data.map((event) => ({
        race_lane_result_id: event.raceLaneResultId || "NA",
        race_day_race_id: event.raceDayRaceId || "NA",
        car_no: event.carNo || "NA",
        driver: event.driver || "NA",
        car_class: event.carClass || "NA",
        rt:
          typeof event.rt === "number" ? event.rt.toFixed(3) : event.rt || "NA",
        rt_str: event.rtStr || "NA",
        ft60:
          typeof event.ft60 === "number"
            ? event.ft60.toFixed(3)
            : event.ft60 || "NA",
        ft330:
          typeof event.ft330 === "number"
            ? event.ft330.toFixed(3)
            : event.ft330 || "NA",
        win: event.win || "NA",
        dial_in:
          typeof event.dialIn === "number"
            ? event.dialIn.toFixed(3)
            : event.dialIn || "NA",
        mov: event.mov || "NA",
        lane: event.lane || "NA",
        ft8:
          typeof event.ft8 === "number"
            ? event.ft8.toFixed(3)
            : event.ft8 || "NA",
        ft8mph:
          typeof event.ft8mph === "number"
            ? event.ft8mph.toFixed(3)
            : event.ft8mph || "NA",
        ft1000:
          typeof event.ft1000 === "number"
            ? event.ft1000.toFixed(3)
            : event.ft1000 || "NA",
        ft4:
          typeof event.ft4 === "number"
            ? event.ft4.toFixed(3)
            : event.ft4 || "NA",
        ft4mph: event.ft4mph || "NA",
        race_date: event.raceDate || "NA",
        eventName: event.eventName || "NA",
        trackName: event.trackName || "NA",
        category: event.category || "NA",
        round: event.round || "NA",
        incr_race_id: event.incrRaceId || "NA",
        raceUniqueId: event.raceUniqueId || "NA",
        first:
          typeof event.first === "number"
            ? event.first.toFixed(3)
            : event.first || "NA",
        movInches: event.movInches || "NA",
        eventId: event.eventId || "NA",
        raceKey: event.raceKey || "NA",
        indexUsed: event.indexUsed || "NA",
        overUnderQuarterMile: event.overUnderQuarterMile || "NA",
        overUnderEighthMile: event.overUnderEighthMile || "NA",
        overUnder: event.overUnder || "NA",
        driverWatched: event.driverWatched || false,
        carNoWatched: event.carNoWatched || false,
      }));

      setTimeSlipResults(timeSlipResults);
      setCarNumberWishlistLeft(!!timeSlipResults[0]?.carNoWatched);
      setCarNumberWishlistRight(!!timeSlipResults[1]?.carNoWatched);
      setDriverNameWishlistLeft(!!timeSlipResults[0]?.driverWatched);
      setDriverNameWishlistRight(!!timeSlipResults[1]?.driverWatched);

      if (timeSlipResults.length > 0) {
        const firstResult = timeSlipResults[0];
        setMov(firstResult.mov ? firstResult.mov : "NA");
        setEventName(firstResult.eventName ? firstResult.eventName : "NA");
        setTrackName(firstResult.trackName ? firstResult.trackName : "NA");
        setCategory(firstResult.category ? firstResult.category : "NA");
        setRound(firstResult.round ? firstResult.round : "NA");
        setRaceUniqueId(firstResult.raceUniqueId);
        setMov_inches(firstResult.movInches ? firstResult.movInches : "NA");
        setEventId(firstResult.eventId || "");
        setRaceKeyId(firstResult.raceKey);
        raceKeyIdRef.current = firstResult.raceKey;
      }

      setLoading(false);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const formatDateRaceUniqueId = (timestamp) => {
    try {
      const datePart = timestamp.substring(0, 10);
      const [month, day, year] = datePart.split("-");

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthName = monthNames[parseInt(month, 10) - 1];

      const timePart =
        timestamp.substring(11, 13) +
        ":" +
        timestamp.substring(14, 16) +
        ":" +
        timestamp.substring(17, 19);

      const formattedDate = `${day}/${monthName}/${year}`;
      const formattedTime = `${timePart}`;
      return { formattedDate, formattedTime };
    } catch (error) {
      console.error("Error formatting date:", error);
      return { formattedDate: "NA", formattedTime: "NA" };
    }
  };

  const { formattedDate, formattedTime } = formatDateRaceUniqueId(raceUniqueId);

  // Only show the run's incremental timing data once the run is finished: a win
  // is available, or (no win) the slip is at least five minutes old.
  const slipReady = isSlipReady(timeSlipResults);

  const convertFtToInches = (value) => {
    const feet = Math.floor(value / 12);
    const inches = value % 12;

    if (isNaN(feet)) {
      return "-";
    }
    return `${feet}′ ${inches.toFixed(0)}″`;
  };

  const fmtTime = (v) =>
    v === null || v === undefined || v === "" || v === "NA" ? "-" : v;

  const DriverModal = ({ driver, onClose }) => {
    const [deltaData, setDeltaData] = useState({
      incrRaceId: 0,
      deltaFt60: 0,
      deltaFt330: 0,
      deltaFt1000: 0,
      deltaDialInTime: 0,
      deltaRt: 0,
      delta60Time: 0,
      delta330Time: 0,
      delta8ThMileTime: 0,
      delta8ThMileTimeMph: 0,
      delta1000Time: 0,
      delta4ThMileTime: 0,
      delta4ThMileTimeMph: 0,
      category: 0,
      round: 0,
    });

    useEffect(() => {
      if (!driver) return;

      const fetchDeltaData = async () => {
        const requestData = {
          raceKey: driver.raceKey,
          name: driver.driver,
        };

        const apiUrl = API_DELTA_VALUE_URL;

        try {
          const response = await api.post(apiUrl, requestData, {
            withCredentials: true,
          });
          const data = response.data;

          setDeltaData({
            incrRaceId: data.incrRaceId || 0,
            deltaFt60: data.deltaFt60 || 0,
            deltaFt330: data.deltaFt330 || 0,
            deltaFt1000: data.deltaFt1000 || 0,
            deltaDialInTime: data.deltaDialInTime || 0,
            deltaRt: data.deltaRt || 0,
            delta60Time: data.delta60Time || 0,
            delta330Time: data.delta330Time || 0,
            delta8ThMileTime: data.delta8ThMileTime || 0,
            delta8ThMileTimeMph: data.delta8ThMileTimeMph || 0,
            delta1000Time: data.delta1000Time || 0,
            delta4ThMileTime: data.delta4ThMileTime || 0,
            delta4ThMileTimeMph: data.delta4ThMileTimeMph || 0,
            category: data.category || 0,
            round: data.round || 0,
          });
        } catch (error) {
          console.error("Error fetching delta data:", error);
        }
      };

      fetchDeltaData();
    }, [driver]);

    if (!driver) return null;




    return (
      <div className="modal" id="modal">
        <div className="modal-content">
          <h2>{driver.driver}</h2>

          <table className="race-data-table">
            <tbody>
              <tr>
                <th></th>

                <th>
                  Present Race Data ({category}, {round})
                </th>
                <th>
                  Previous Race Data ({deltaData.category}, {deltaData.round})
                </th>
                <th>Delta</th>
              </tr>

              <tr>
                <th>Dial-in Time</th>
                <td>{fmtTime(driver.dial_in)}</td>
                <td>{deltaData.deltaDialInTime.toFixed(3)}</td>
                <td>
                  {driver.dial_in && driver.dial_in !== "NA"
                    ? (driver.dial_in - deltaData.deltaDialInTime).toFixed(3)
                    : 0}
                </td>
              </tr>
              <tr>
                <th>Reaction Time</th>
                <td>{fmtTime(driver.rt)}</td>
                <td>{deltaData.deltaRt.toFixed(3)}</td>
                <td>
                  {driver.rt && driver.rt !== "NA"
                    ? (driver.rt - deltaData.deltaRt).toFixed(3)
                    : 0}
                </td>
              </tr>
              <tr>
                <th>60' Time</th>
                <td>{fmtTime(driver.ft60)}</td>
                <td>{deltaData.deltaFt60.toFixed(3)}</td>
                <td>
                  {driver.ft60 && driver.ft60 !== "NA"
                    ? (driver.ft60 - deltaData.deltaFt60).toFixed(3)
                    : 0}
                </td>
              </tr>

              <tr>
                <th>330' Time</th>
                <td>{fmtTime(driver.ft330)}</td>
                <td>{deltaData.deltaFt330.toFixed(3)}</td>
                <td>
                  {driver.ft330 && driver.ft330 !== "NA"
                    ? (driver.ft330 - deltaData.deltaFt330).toFixed(3)
                    : 0}
                </td>
              </tr>

              <tr>
                <th>1/8 Mile ET</th>
                <td>{fmtTime(driver.ft8)}</td>
                <td>{deltaData.delta8ThMileTime.toFixed(3)}</td>
                <td>
                  {driver.ft8 && driver.ft8 !== "NA"
                    ? (driver.ft8 - deltaData.delta8ThMileTime).toFixed(3)
                    : 0}
                </td>
              </tr>
              <tr>
                <th>1/8 Mile (MPH) </th>
                <td>{fmtTime(driver.ft8mph)}</td>
                <td>{deltaData.delta8ThMileTimeMph.toFixed(3)}</td>
                <td>
                  {driver.ft8mph && driver.ft8mph !== "NA"
                    ? (driver.ft8mph - deltaData.delta8ThMileTimeMph).toFixed(3)
                    : 0}
                </td>
              </tr>

              <tr>
                <th>1000' Time</th>
                <td>{fmtTime(driver.ft1000)}</td>
                <td>{deltaData.deltaFt1000.toFixed(3)}</td>
                <td>
                  {driver.ft1000 && driver.ft1000 !== "NA"
                    ? (driver.ft1000 - deltaData.deltaFt1000).toFixed(3)
                    : 0}
                </td>
              </tr>

              <tr>
                <th>1/4 Mile ET</th>
                <td>{fmtTime(driver.ft4)}</td>
                <td>{deltaData.delta4ThMileTime.toFixed(3)}</td>
                <td>
                  {driver.ft4 && driver.ft4 !== "NA"
                    ? (driver.ft4 - deltaData.delta4ThMileTime).toFixed(3)
                    : 0}
                </td>
              </tr>
              <tr>
                <th>1/4 Mile (MPH)</th>
                <td>{fmtTime(driver.ft4mph)}</td>
                <td>{deltaData.delta4ThMileTimeMph.toFixed(3)}</td>
                <td>
                  {driver.ft4mph && driver.ft4mph !== "NA"
                    ? (driver.ft4mph - deltaData.delta4ThMileTimeMph).toFixed(3)
                    : 0}
                </td>
              </tr>
            </tbody>
          </table>
          <button onClick={onClose} className="search-button-timeslip">
            Close
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    fetchData();
    // }, [handleFirstData, handleChangeIncreRaceIdData, mainScreenFlag]);
  }, [handleFirstData, mainScreenFlag]);

  useEffect(() => {
    fetchDataOnDirectionChange();
    // }, [handleFirstData, handleChangeIncreRaceIdData, mainScreenFlag]);
  }, [handleChangeDirection]);

  useEffect(() => {
    eventIdRef.current = eventId;
  }, [eventId]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchFreshData(raceKeyIdRef.current);
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  // While a slip is gated (not yet ready), re-evaluate periodically so the
  // age-based threshold flips the display on without needing a data refresh.
  useEffect(() => {
    if (slipReady) return;
    const intervalId = setInterval(() => {
      setReadinessTick((t) => t + 1);
    }, 30000);
    return () => clearInterval(intervalId);
  }, [slipReady]);

  return (
    <div className="time-slip-container">
      {user && (
        <InstallPromptBanner
          showAndroidPrompt={showAndroidPrompt}
          showIOSGuide={showIOSGuide}
          onInstall={handleInstallClick}
          onDismiss={handleDismiss}
          isAndroid={isAndroid}
          isIOS={isIOS}
        />
      )}

      {loading ? (
        <div className="loader"></div>
      ) : !timeSlipResults || timeSlipResults.length === 0 ? (
        <div {...swipeHandlers}>
          <div className="event-header no-data-state">
            <button className="arrow-button" onClick={handleLeftArrowClick}>
              &#8592;
            </button>
            <div className="no-data-message">
              <div className="no-data-text">No data available</div>

              <div className="no-data-actions">
                <button
                  type="submit"
                  className="tsv-button"
                  onClick={handleLatestData}
                >
                  Latest
                </button>
              </div>
            </div>
            <div className="header-actions">
              <button className="arrow-button" onClick={handleRightArrowClick}>
                &#8594;
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          {...swipeHandlers}
          ref={(el) => {
            swipeHandlers.ref(el);
            slipRef.current = el;
          }}
        >
          <div id="tour-slip-nav" className="event-header">
            <button
              type="button"
              className="share-button"
              onClick={handleShare}
              disabled={sharing}
              aria-label="Share time slip"
              title="Share"
            >
              <FaShareAlt />
            </button>
            <button
              type="button"
              className="event-header-print"
              onClick={handlePrint}
              aria-label="Print time slip"
              title="Print"
            >
              <FaPrint />
            </button>
            <button
              className="arrow-button left-arrow"
              onClick={handleLeftArrowClick}
            >
              &#8592;
            </button>
            <div className="event-info">
              <p className="event-name">
                <span className="track-name">{trackName}</span>
                <span className="event-row">
                  <span className="event-title">{eventName}</span>
                </span>
              </p>

              <p className="race-details">
                {category} , {round}
              </p>
              <p className="date-time">
                <b>Date:</b> {formattedDate} <b>Time: </b>
                {formattedTime}
              </p>
            </div>
            <div className="header-actions">
              <button
                className="arrow-button right-arrow"
                onClick={handleRightArrowClick}
              >
                &#8594;
              </button>
            </div>
          </div>
          <div>
            <table id="tour-slip-drivers" className="race-data-table-driverdata ">
              <tbody>
                <tr>
                  <th>Car Number</th>
                  {timeSlipResults.map((racer, index) => (
                    <td key={index}>
                      {racer.car_no && racer.car_no !== "NA" ? (
                        <button
                          type="button"
                          className="link-button"
                          onClick={() =>
                            goAutoSearch("carNumber", racer.car_no)
                          }
                          title={`Search races for car #${racer.car_no}`}
                        >
                          {racer.car_no}
                        </button>
                      ) : (
                        racer.car_no
                      )}
                      {racer.car_no && racer.car_no !== "NA" && (
                        <button type="button" className="driver-wishlist-btn" onClick={() => handleCarNumberWishlist(racer.car_no, index)}>
                          <FaEye style={{ fontSize: '15px', color: (index === 0 ? carNumberWishlistLeft : carNumberWishlistRight) ? 'currentColor' : '#888' }} />
                        </button>
                      )}
                    </td>
                  ))}
                </tr>

                <tr>
                  <th>Driver Name</th>
                  {timeSlipResults.map((racer, index) => (
                    <td key={index}>
                      {racer.driver && racer.driver !== "NA" ? (
                        <button
                          type="button"
                          className="link-button"
                          onClick={() =>
                            goAutoSearch("driverName", racer.driver)
                          }
                          title={`Search races for ${racer.driver}`}
                        >
                          {racer.driver}
                          {racer.win === "WIN" && (
                            <span className="win-tag">WIN</span>
                          )}
                        </button>
                      ) : (
                        <>
                          {racer.driver}
                          {racer.win === "WIN" && (
                            <span className="win-tag">WIN</span>
                          )}
                        </>
                      )}
                      {racer.driver && racer.driver !== "NA" && (
                        <button
                          type="button"
                          className="driver-details-btn"
                          onClick={() => {
                            setSelectedDriver(racer);
                            setShowModal(toggleModal);
                          }}
                          aria-label={`Compare ${racer.driver}'s current race to previous`}
                          title="Compare to previous race"
                        >
                          <FaExchangeAlt />
                        </button>
                      )}
                      {racer.driver && racer.driver !== "NA" && (
                        <button type="button" className="driver-wishlist-btn" onClick={() => handleDriverNameWishlist(racer.driver, index)}>
                          <FaEye style={{ fontSize: '15px', color: (index === 0 ? driverNameWishlistLeft : driverNameWishlistRight) ? 'currentColor' : '#888' }} />
                        </button>
                      )}
                    </td>
                  ))}
                </tr>

                <tr>
                  <th>Class</th>
                  {timeSlipResults.map((racer, index) => (
                    <td key={index}>
                      {racer.car_class && racer.car_class !== "NA" ? (
                        <button
                          type="button"
                          className="link-button"
                          onClick={() =>
                            goAutoSearch("carClass", racer.car_class)
                          }
                          title={`Search races for class ${racer.car_class}`}
                        >
                          {racer.car_class}
                        </button>
                      ) : (
                        racer.car_class
                      )}
                      {/* {racer.car_class && racer.car_class !== "NA" && (
                        <button type="button" className="driver-wishlist-btn" onClick={() => toggleWishlist(`class:${racer.car_class}`)}>
                          <FaEye style={{ fontSize: '15px', color: wishlist.has(`class:${racer.car_class}`) ? 'currentColor' : '#888' }} />
                        </button>
                      )} */}
                    </td>
                  ))}
                </tr>

                {slipReady && (
                  <>
                    <tr>
                      <th>Index</th>
                      {timeSlipResults.map((racer, index) => (
                        <td key={index}>{fmtTime(racer.indexUsed)}</td>
                      ))}
                    </tr>

                    <tr>
                      <th>Over / Under</th>
                      {timeSlipResults.map((racer, index) => (
                        <td key={index}>{fmtTime(racer.overUnder)}</td>
                      ))}
                    </tr>
                  </>
                )}
              </tbody>
            </table>

            {showModal && (
              <DriverModal
                driver={selectedDriver}
                onClose={() => setShowModal(false)}
              />
            )}
          </div>

          {!slipReady && (
            <div className="slip-pending-banner">
              Run in progress — results pending
            </div>
          )}

          {slipReady && (
          <>
          <table id="tour-slip-times" className="race-data-table">
            <tbody>
              <tr>
                <th>Dial-in Time</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.dial_in)}</td>
                ))}
              </tr>
              <tr>
                <th>Reaction Time</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.rt)}</td>
                ))}
              </tr>
              <tr>
                <th>60' Time</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft60)}</td>
                ))}
              </tr>
              <tr>
                <th>330' Time</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft330)}</td>
                ))}
              </tr>
              <tr>
                <th>1/8 Mile ET</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft8)}</td>
                ))}
              </tr>
              <tr>
                <th>1/8 Mile (MPH)</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft8mph)}</td>
                ))}
              </tr>
              <tr>
                <th>1000' Time</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft1000)}</td>
                ))}
              </tr>
              <tr>
                <th>1/4 Mile ET</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft4)}</td>
                ))}
              </tr>
              <tr>
                <th>1/4 Mile (MPH)</th>
                {timeSlipResults.map((racer, index) => (
                  <td key={index}>{fmtTime(racer.ft4mph)}</td>
                ))}
              </tr>
            </tbody>
          </table>

          <table
            className={
              timeSlipResults[1]
                ? "race-data-table-last"
                : "race-data-table-last-noFirst"
            }
          >
            <tbody>
              <tr>
                <th>
                  {timeSlipResults[0]?.first !== "NA" &&
                  timeSlipResults[1]?.first === "NA"
                    ? "Left 1st"
                    : Array.isArray(timeSlipResults) &&
                        timeSlipResults[0]?.first === "NA" &&
                        timeSlipResults[1]?.first !== "NA"
                      ? "Right 1st"
                      : "1st"}
                </th>
                {(() => {
                  const validRacer = timeSlipResults.find(
                    (racer) => racer.first && racer.first !== "NA",
                  );
                  return <td>{fmtTime(validRacer?.first)}</td>;
                })()}
              </tr>
              <tr>
                <th>Margin of Victory (MOV)</th>
                <td>
                  {fmtTime(mov)} / {convertFtToInches(mov_inches)}
                </td>
              </tr>
            </tbody>
          </table>
          </>
          )}
          <footer className="footer">
            <div className="footer-logo-data"></div>

            <div className="footer-logo-container">
              <a
                href="https://microstrat.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={msiLogo}
                  alt="Micro Strategies Logo"
                  className="footer-logo"
                />
              </a>
              <a
                href="https://draginsights.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={dragInsightsLogo}
                  alt="Drag Insights Logo"
                  className="footer-logo"
                />
              </a>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
};

export default TimeSlipView;
